import { Resource } from "./permissionType";

export const normalizePermissions = (resources: Resource[]) => {
  const map = new Map<string, boolean>();

  for (const r of resources) {
    for (const p of r.permissions) {
      for (const a of p.actions) {
        if (a.checked) {
          map.set(`${r.resource}.${p.name}.${a.name}`, true);
        }
      }
    }
  }

  return map;
};
